import t from "../../../../i18n";
import type { ParsingError, ParsingErrorMessageMap } from "../../types";
import { ConverterErrorType } from "../types";

export const sourceParsingErrorMessages: ParsingErrorMessageMap<ConverterErrorType> = {
  [ConverterErrorType.DUPLICATED_SNAPSHOT_DATE]: () =>
    t("dataSource.import.parsing.error.duplicated_snapshot_date"),
  /** Occure when a snapshot has no date */
  [ConverterErrorType.MISSING_SNAPSHOT_DATE]: () =>
    t("dataSource.import.parsing.error.missing_snapshot_date"),
  /** Occure when two snapshots on the same date diverge in acquisition date or label or group */
  [ConverterErrorType.SNAPSHOT_METADATA_MISSMATCH]: () =>
    t("dataSource.import.parsing.error.snapshot_metadata_missmatch"),
  /** Occure when a sensor value is not a number */
  [ConverterErrorType.INVALID_SENSOR_VALUE]: () =>
    t("dataSource.import.parsing.error.invalid_sensor_value"),
  /** Occure when file shares different sourceId */
  [ConverterErrorType.CONFLICTING_SOURCE_ID]: () =>
    t("dataSource.import.parsing.error.conflicting_source_id"),
  /** Occure when file shares different values for a given snapshot */
  [ConverterErrorType.CONFLICTING_SENSOR_VALUE]: () =>
    t("dataSource.import.parsing.error.conflicting_sensor_value"),
  [ConverterErrorType.INVALID_SOURCE_ID]: () =>
    t("dataSource.import.parsing.error.invalid_source_id"),
  [ConverterErrorType.INVALID_LABEL_TOO_LONG]: () =>
    t("dataSource.import.parsing.error.invalid_label_too_long"),
  [ConverterErrorType.INVALID_GROUP_TOO_LONG]: () =>
    t("dataSource.import.parsing.error.invalid_group_too_long"),
  /** JSON Import */
  [ConverterErrorType.INVALID_JSON]: () => t("dataSource.import.parsing.error.invalid_json"),
  [ConverterErrorType.MISSING_SOURCE_ID]: () =>
    t("dataSource.import.parsing.error.missing_source_id"),
  [ConverterErrorType.MALFORMED_JSON]: () => t("dataSource.import.parsing.error.malformed_json"),
  [ConverterErrorType.EMPTY_DATA_EXTRACTION]: () =>
    t("dataSource.import.parsing.error.empty_data_extraction"),
  [ConverterErrorType.INVALID_SENSOR_VALUE_MISSING_MEAN]: () =>
    t("dataSource.import.parsing.error.invalid_sensor_value_missing_mean"),
};
/**
 * @description Get error message from error kind.
 * @param error source parsing error
 * @returns Translated error message.
 */
export const getSourceParsingErrorMessage = (error: ParsingError<ConverterErrorType>) => {
  const errorMessage = sourceParsingErrorMessages[error.kind];
  return errorMessage ? errorMessage(error.data) : "Unknown error";
};
